<template>
    <div class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 bg-charcoal-800">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <img class="mx-auto w-64" src="@/assets/img/tap-logo.png" alt="TAP"/>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 sm:px-10">

                <div class="bg-red-200 p-4 mb-4" v-show="errorMessage">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <svg class="h-5 w-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/>
                            </svg>
                        </div>
                        <div class="ml-3">
                            <h3 class="text-xs leading-5 text-red-800">
                                {{ errorMessage }}
                            </h3>
                        </div>
                    </div>
                </div>

                <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(resetPassword)">
                        <div class="mt-6">
                            <label for="password" class="block text-sm font-medium leading-5 text-gray-700">
                                Enter your new password
                            </label>
                            <div class="mt-1">
                                <ValidationProvider name="Password" mode="lazy" rules="required|password:@ConfirmPassword" v-slot="{ errors }" tag="div">
                                    <input id="password" type="password" autocomplete="off" v-model="password" class="appearance-none block w-full px-3 py-2 border border-gray-300 placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                                    <span class="text-xs text-red-500 absolute">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="mt-6">
                            <label for="confirm-password" class="block text-sm font-medium leading-5 text-gray-700">
                                Confirm password
                            </label>
                            <div class="mt-1">
                                <ValidationProvider name="ConfirmPassword" mode="lazy" rules="required" v-slot="{ errors }" tag="div">
                                    <input id="confirm-password" type="password" autocomplete="off" v-model="retype_password" class="appearance-none block w-full px-3 py-2 border border-gray-300 placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                                    <span class="text-xs text-red-500 absolute">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>

                        <div class="mt-6">
                            <span class="block w-full rounded-md shadow-sm">
                                <button type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-default-500 hover:bg-default-600 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out" :disabled="submitted">
                                    <svg width="22" height="22" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff" class="mr-2" v-show="submitted">
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(1 1)" stroke-width="2">
                                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                    <animateTransform
                                                        attributeName="transform"
                                                        type="rotate"
                                                        from="0 18 18"
                                                        to="360 18 18"
                                                        dur="1s"
                                                        repeatCount="indefinite"/>
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                    Reset Password
                                </button>
                             </span>
                        </div>
                    </form>
                </ValidationObserver>

            </div>
        </div>

        <div class="w-full text-center py-4 text-grey-light text-sm">
            <p>{{ year }} © WebManage Pty Ltd. <a href="https://www.webmanage.com.au" class="no-underline text-grey-light" target="_blank">WebManage Pty Ltd</a></p>
        </div>
        <notifications group="main" position="bottom right" />
    </div>
</template>

<script>
    import axios from 'axios'
    import { extend } from 'vee-validate';

    extend('password', {
        params: ['target'],
        validate(value, { target }) {
            return value === target;
        },
        message: 'Password confirmation does not match'
    });

    export default {
        name: "ResetPassword",
        data: function () {
            return {
                token: '',
                password: '',
                retype_password: '',
                year: (new Date()).getFullYear(),
                submitted: false,
                errorMessage: '',
            }
        },
        beforeMount() {
            this.token = this.getUrlParameter('token');

            axios.post(process.env.VUE_APP_API_URL + '/check-token', {
                token: this.token
            }).then(response => {
                if (!response.data.success){
                    this.$router.push('login');
                }
            });
        },
        methods: {
            resetPassword: function(){
                this.submitted = true;
                this.errorMessage = '';

                axios.post(process.env.VUE_APP_API_URL + '/reset-password', {
                    password: this.password,
                    token: this.token
                }).then(response => {
                    if (response.data.success){
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Success',
                            text: response.data.message,
                            duration: 2000
                        });
                        let self = this;
                        setTimeout(function() {
                            self.$router.push('login');
                        }, 2000);
                    } else {
                        this.submitted = false;
                        this.errorMessage = response.data.message;
                        this.password ='';
                        this.retype_password = '';
                    }
                }).catch(() => {
                    this.submitted = false;
                    this.$notify({
                        group: 'main',
                        position: 'bottom right',
                        type: 'error',
                        title: 'Error',
                        text: 'An error occurred. Please contact system administrator.',
                        duration: 2000
                    });
                    this.password ='';
                    this.retype_password = '';
                });
            },
            getUrlParameter: function(name){
                name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
                var results = regex.exec(location.search);
                return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
            }
        }
    }
</script>
